<div class="progress-container">
  <div class="progress-bar" [style.width.%]="scrollPercentage"></div>
</div>

<div *ngIf="isShow" class="pc">
  <div class="ol text-white d-flex justify-content-center align-items-center" (click)="scrollToTop()"><i
      class="fa fa-arrow-up fs-5" aria-hidden="true"></i></div>
  <div class="bg"></div>
</div>